import { initializeCommand, createTaskRunner } from '../index';
import { replaceVsCodeConfig } from '../config';

export const command = 'config:ide';
export const describe = `Configure the IDE based on the current services and containers.`;

export const builder = () => {
  initializeCommand();
};

export const handler = async(): Promise<void> => {
  const taskRunner = createTaskRunner({
    tasks: [{
      title: 'Generate VSCode configuration',
      task: async (): Promise<void> => {
        await replaceVsCodeConfig();
      },
    }],
  });

  await taskRunner.run();  
};
